import dayjs from 'dayjs'

export default function ActiveFilters({ activeFilters, dateFrom, dateTo, setDateFrom, setDateTo, setMakeRequest, cleanListItem }) {
   return (
      <>
         {/* Блок додавання активних фільтрів */}
         <div className='active-filter-attributes'>
            {/* <div className='active-filter-attributes_title'>
                      <span>Active Filters:</span>
                    </div> */}
            <div className='active-filter-attributes_items'>
               {activeFilters.length > 0 || (dateFrom && dateTo) ? <div className='active-filter-attributes_items_title'>
                  <span>Active Filters:</span>
               </div> : ''}
               {activeFilters.map(elem => {

                  return (
                     <div className='active-filter-item' key={elem.filterSlug}>
                        <div className='active-filter-item__infoBlock'>
                           <div className='active-filter-item__infoBlock__filterName'>
                              {elem.filterLabel}
                              :
                           </div>
                           <div className='active-filter-item__infoBlock__attributeName'>{elem.filterSlug === 'Owners' ? `${elem.optionFirstName} ${elem.optionLastName}` : (elem.filterSlug === 'Posts' || elem.filterSlug === 'Projects') ? elem.optionId : elem.optionLabel}</div>
                        </div>
                        <div className='active-filter-item__deleteIcon' onClick={() => cleanListItem(elem.filterSlug)}>
                           <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15 5L5 15M5 5L15 15" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                           </svg>
                        </div>
                     </div>

                  )
               })
               }
               {
                  (dateFrom && dateTo) ?
                     <>
                        <div className='active-filter-item'>
                           <div className='active-filter-item__infoBlock'>
                              <div className='active-filter-item__infoBlock__filterName'>Start date {' '}:</div>
                              <div className='active-filter-item__infoBlock__attributeName'>{`${dayjs(dateFrom).format('YYYY-MM-DD')} to ${dayjs(dateTo).format('YYYY-MM-DD')}`}</div>
                           </div>
                           <div className='active-filter-item__deleteIcon'
                              onClick={() => {
                                 setDateFrom(null)
                                 setDateTo(null)
                                 setMakeRequest(true)
                              }}
                           >
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path d="M15 5L5 15M5 5L15 15" stroke="#434349" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                           </div>
                        </div>
                     </> : ''
               }

            </div>
         </div>
         {/* Блок додавання активних фільтрів (верх)*/}

      </>
   )
}